<!-- Par pays -->
<div class="single-slidebar">
  <h4>TOP 5 des pays</h4>
  <ul class="cat-list">
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Bénin</p><span>104</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Mali</p><span>98</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Togo</p><span>97</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Guinnée</p><span>82</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Côte d'ivoire</p><span>57</span>
      </a>
    </li>
  </ul>
</div>

<!-- Par ville -->
<div class="single-slidebar">
  <h4>TOP 5 des villes</h4>
  <ul class="cat-list">
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Cotonou</p><span>142</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Lomé</p><span>131</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Parakou</p><span>89</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Abidjan</p><span>74</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Porto-novo</p><span>45</span>
      </a>
    </li>
  </ul>
</div>

<!-- Par métier -->
<div class="single-slidebar">
  <h4>TOP 5 des métiers</h4>
  <ul class="cat-list">
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Comptabilité & finance</p><span>142</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Informatique & Télécom</p><span>131</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Marketing & commerce</p><span>89</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Ressources humaines</p><span>74</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Assurance</p><span>45</span>
      </a>
    </li>
  </ul>
</div>

<!-- Par secteur d'activité -->
<div class="single-slidebar">
  <h4>TOP 5 des secteurs d'activités</h4>
  <ul class="cat-list">
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Finance & assurance</p><span>142</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Réseau télécom</p><span>131</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Adrministration</p><span>89</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Art & culture</p><span>74</span>
      </a>
    </li>
    <li>
      <a class="justify-content-between d-flex" href="#">
        <p>Agriculture & pêche</p><span>45</span>
      </a>
    </li>
  </ul>
</div>